const mapElement = document.getElementById( 'map' );
const latitude = parseFloat( mapElement.getAttribute( 'data-latitude' ) );
const longitude = parseFloat( mapElement.getAttribute( 'data-longitude' ) );

const mapParameters = {
	center: {
		lat: latitude,
		lng: longitude,
	},
	zoom: 12,
	styles: window.googleMap.style
};

const map = new google.maps.Map( mapElement, mapParameters );
const stockist = {
	position: {
		lat: latitude,
		lng: longitude
	},
	map: map,
	icon: window.googleMap.icon
};
const stockistMarker = new google.maps.Marker( stockist );
